/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckSquareCutIcon20Solid = forwardRef('CheckSquareCutIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6 2a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V6a4.05 4.05 0 0 0-.012-.319l-6.61 6.61a2.613 2.613 0 0 1-3.694 0L5.195 9.8A1.05 1.05 0 1 1 6.68 8.316l2.489 2.49c.2.2.524.2.725 0l7.262-7.263A3.993 3.993 0 0 0 14 2H6Z" })));
});
